import { createActionsHook } from 'src/lib/sweetState';

import { type Actions, ComplianceStore, type State } from './ComplianceStore';

export const useComplianceActions = createActionsHook<State, Actions>(ComplianceStore);
